import {
    ActiveFilter,
    FilterConfig,
    FilterOptions,
    FilterItem,
} from './useFilterSearchSection.types'

export const convertFiltersToActiveFilters = (
    filterConfig: FilterConfig,
    getFilterOptions: (filterType: any) => FilterOptions
): ActiveFilter[] => {
    return Object.entries(filterConfig)
        .map(([filterType, config]) => {
            const filterOptions = getFilterOptions(filterType)
            const activeOptions = filterOptions.activeOptions || []

            if (activeOptions.length === 0) return null

            const filterItems: FilterItem[] = activeOptions.map((optionId) => {
                const option = filterOptions.options.find(
                    (opt: any) => opt.id === optionId
                )
                return {
                    id: optionId,
                    name: option?.label || optionId,
                    icon: option?.icon,
                }
            })

            return {
                filterName: config.label,
                filters: filterItems,
            }
        })
        .filter(Boolean) as ActiveFilter[]
}
